import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import UpperQuote from "../Icons/UpperQuote";
const useStyles = makeStyles(({
  palette,
  typography,
  breakpoints
}) => ({
  icon: {
    color: palette.primary.main,
    fontSize: typography.pxToRem(18),
    marginRight: 8,
    transform: "translateY(-10px)"
  },
  text: {
    width: "80%",
    wordWrap: "break-word",
    fontSize: typography.pxToRem(14),
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(13)
    }
  }
}));

const QuotedMessage = ({
  message,
  className
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(UpperQuote, {
    className: styles.icon
  }), /*#__PURE__*/React.createElement(Typography, {
    className: styles.text
  }, message));
};

export default QuotedMessage;